interface Topic {
  name: string;
  heat: string;
  tag: string;
}

const TOPICS: Topic[] = [
  { name: '我独自升级', heat: '892万', tag: '韩漫' },
  { name: '咒术回战', heat: '765万', tag: '日漫' },
  { name: '一人之下', heat: '698万', tag: '国漫' },
  { name: '全职猎人', heat: '634万', tag: '日漫' },
  { name: '外貌至上主义', heat: '587万', tag: '韩漫' },
  { name: '镇魂街', heat: '542万', tag: '国漫' },
  { name: '间谍过家家', heat: '498万', tag: '日漫' },
  { name: '女神降临', heat: '456万', tag: '韩漫' },
  { name: '狐妖小红娘', heat: '423万', tag: '国漫' },
  { name: '电锯人', heat: '389万', tag: '日漫' },
  { name: '梨泰院Class', heat: '351万', tag: '韩漫' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-50 scroll-mt-[72px]">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">热门话题</h2>
          <p className="text-foreground-500 text-sm mt-3">大家都在讨论的漫画作品，看看哪部是你的菜</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS.map((topic) => (
            <a
              key={topic.name}
              href="#topics"
              className="group flex items-center gap-3 px-4 py-3 bg-background-100 hover:bg-primary-50 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <span className={`inline-flex px-2 py-0.5 rounded-md text-xs font-medium ${
                topic.tag === '韩漫' ? 'bg-accent-100 text-accent-700' :
                topic.tag === '日漫' ? 'bg-primary-100 text-primary-700' :
                'bg-secondary-100 text-secondary-700'
              }`}>
                {topic.tag}
              </span>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {topic.name}
              </span>
              <span className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-fire-line w-4 h-4 flex items-center justify-center"></i>
                {topic.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}